import { render, staticRenderFns } from "./DeliverableListUsers.vue?vue&type=template&id=00b8f038&"
import script from "./DeliverableListUsers.vue?vue&type=script&lang=js&"
export * from "./DeliverableListUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b8f038')) {
      api.createRecord('00b8f038', component.options)
    } else {
      api.reload('00b8f038', component.options)
    }
    module.hot.accept("./DeliverableListUsers.vue?vue&type=template&id=00b8f038&", function () {
      api.rerender('00b8f038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableListUsers.vue"
export default component.exports